import { Button, ConfigProvider, DatePicker, Form, Input, Radio, Select, Space, message } from "antd";
import "antd/dist/antd.css";
import i18n from "i18next";
import moment from "moment";
import "moment/locale/fr";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import "react-tagsinput/react-tagsinput.css";
import { bindActionCreators } from "redux";
import TagsInput from "../../../components/Tagsinput";
import Loading from "../../../components/loading";
import { SecurityToken } from "../../../components/securite";
import { requestApiAddEvent } from "../../../store/actions/actions";
import { getTokenDecode } from "../../../utils/security";
import styles from "./newEventSSO.module.css";

const { Option } = Select;

const today = `${moment()._d.getDate()}/${moment()._d.getMonth() + 1}/${moment()._d.getFullYear()}`;
const EventSSO = (props) => {
  const [form] = Form.useForm();

  const [mails, setMails] = useState([]);
  const [mail_sponsor, setMail_sponsor] = useState("");
  const [loading, setLoading] = useState(true);
  const [finish, setFinish] = useState(false);
  const [mailsStatus, setMailsStatus] = useState("");

  const [locale, setLocale] = useState();
  const [language, setLanguage] = useState();

  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    setLoading(SecurityToken(props.history));
    document.title = "Création évenement - Wifi Guest";
    let mail_sponsor = getTokenDecode(sessionStorage.getItem("access_token")).email;
    setMail_sponsor(mail_sponsor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLanguage(i18n.language[0]);
    if (language === "f") {
      const data = require("antd/lib/locale/fr_FR");
      setLocale(data.default);
    } else {
      setLocale("en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, language]);

  const getItems = (items) => {
    setMails(items);
  };
  const callbackAddEvent = (res) => {
    console.log(res);
    if (res === 201 || res === 200) {
      message.success(<span style={{ marginLeft: "5px" }}>{props.t("event_sso.server.success")}</span>, {
        autoClose: 5000,
      });
      setFinish(true);
    } else {
      message.error(<span style={{ marginLeft: "5px" }}>{props.t("event_sso.server.error")}</span>, {
        autoClose: 5000,
      });
    }
  };

  const addEventHandler = (values) => {
    let date = values.startAt._d;
    if (mails.length === 0) {
      setMailsStatus("error");
      message.error(<span style={{ marginLeft: "5px" }}>{props.t("event_sso.tagsinput.no_mail")}</span>);
    } else {
      setButtonDisabled(true);
      props.requestApiAddEvent({
        body: {
          guests: mails,
          event: values.eventname,
          sponsor: mail_sponsor,
          startAt: moment(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`, "DD/MM/YYYY").format("YYYY-MM-DD"),
          validity_period: (values.duration * 86400).toString(),
          language: values.language,
        },
        callback: (e) => {
          setButtonDisabled(false);
          callbackAddEvent(e);
        },
      });
    }
  };

  useEffect(() => {
    if (mails.length >= 1) {
      setMailsStatus("");
    }
  }, [mails]);

  const { t } = props;
  if (finish) {
    return <Redirect to={"/home-sso"} />;
  }
  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.form_container}>
      <h2>{t("event_sso.title")}</h2>
      <ConfigProvider locale={locale}>
        <Form
          name="form_event"
          initialValues={{
            remember: true,
            startAt: moment(today, "DD/MM/YYYY"),
            duration: "1",
            language: "fr",
          }}
          onFinish={addEventHandler}
          autoComplete="off"
          layout="vertical"
          className={styles.form}
          form={form}
        >
          <Form.Item
            label={t("event_sso.label.eventname")}
            name="eventname"
            rules={[
              {
                required: true,
                message: t("event_sso.validation.eventname"),
              },
            ]}
          >
            <Input placeholder={t("event_sso.placeholder.eventname")} />
          </Form.Item>
          <Form.Item label={t("event_sso.label.mails")} name="mails" validateStatus={mailsStatus} hasFeedback>
            <TagsInput getItems={getItems} />
          </Form.Item>
          <div className={styles.form_flex}>
            <Form.Item name="startAt" label={t("event_sso.label.startAt")} rules={[{ required: true }]} className={styles.input_date}>
              <DatePicker className={styles.input_date} placeholder={moment().format("DD/MM/YYYY")} locale={locale} format={t("date_format")} />
            </Form.Item>

            <Form.Item name="duration" label={t("event_sso.label.duration")} rules={[{ required: true }]} className={styles.input_duration}>
              <Select>
                <Option value="1">1 {t("event_sso.select.day")}</Option>
                <Option value="2">2 {t("event_sso.select.days")}</Option>
                <Option value="7">7 {t("event_sso.select.days")}</Option>
              </Select>
            </Form.Item>
            <Form.Item
              className={styles.form__group__item}
              style={{ width: "100%" }}
              name="language"
              label={t("admin.users.edit.label.language")}
              rules={[
                {
                  required: true,
                  message: t("admin.users.edit.validation.language"),
                },
              ]}
            >
              <Radio.Group>
                <Space>
                  <Radio value={"fr"}>{t("admin.users.edit.label.french")}</Radio>
                  <Radio value={"en"}>{t("admin.users.edit.label.english")}</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className={styles.form_footer}>
            <div className={styles.form_footer_mandatory}>
              <p> {t("event_sso.label.mandatory")}</p>
            </div>

            <div className={styles.form_button}>
              <Form.Item>
                <Link to="home-sso">
                  <Button danger size="large">
                    {t("event_sso.button.cancel")}
                  </Button>
                </Link>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" loading={buttonDisabled}>
                  {t("event_sso.button.continue")}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </ConfigProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) => bindActionCreators({ requestApiAddEvent }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EventSSO));
